import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {secureStorage} from "../../functions/secure-storage";
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import {UntypedFormControl} from "@angular/forms";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'app-phone-with-country',
  templateUrl: './phone-with-country.component.html',
  styleUrls: ['./phone-with-country.component.scss']
})
export class PhoneWithCountryComponent implements OnInit, OnChanges, AfterViewInit {
  @Output() phoneValue: any = new EventEmitter();
  @Input() value: any;
  @Input() controlName: any;
  @Input() countryCode: any;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  selectedCountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.Egypt, CountryISO.SaudiArabia];
  currentCountry = secureStorage.getItem('location')?.country;
  phone = new UntypedFormControl()
  constructor() { }

  ngAfterViewInit() {
    setTimeout(() => {
      document.querySelector('.iti__flag-container')?.classList.add('disabled');
      this.phone.setValue(this.value);
    });
  }

  ngOnInit(): void {
    this.selectedCountryISO = 'eg';
    if (this.value) {
      this.controlName.setValue(`${this.value}`);
    }
    this.controlName.valueChanges.pipe(
      untilDestroyed(this)
    ).subscribe(phone => {
      this.phoneValue.emit(this.controlName);
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('value')) {
      this.phone.setValue(changes.value);
    }
  }
}
